/*
 * @Author: raojw
 * @LastEditors: songyzh
 * @Description: 获取系统自定义配置信息
 * @LastEditTime: 2020-08-19 10:15:22
 */

import { getAppConfig } from '@/api/shared';

export default async () => {
  try {
    const config = await getAppConfig();
    const env = process.env.NODE_ENV;

    return {
      config: config[env], // 根据环境过滤
      fullConfig: config
    };
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
